const TOKEN = "useToken";

export const getToken = () => {
  const encodedToken = localStorage.getItem(TOKEN);
  if (encodedToken) return atob(encodedToken);
  return null;
};

export const saveAuth = (token: string) => {
  const encodedToken = btoa(token);
  localStorage.setItem(TOKEN, encodedToken);
};

export const destroyAuth = () => {
  localStorage.removeItem(TOKEN);
};

export default { getToken, saveAuth, destroyAuth };
